import { useEffect, useState } from "react";
import styled from "styled-components";
import { formatarData } from "../../Funcoes/FormatarData"

import { HiOutlineDotsHorizontal } from "react-icons/hi";
import { IoPersonSharp, IoTicket } from "react-icons/io5";
import { FaPlay, FaStop } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { useModal } from "../../contexts/ModalContext";
import Overlay from "../../Componentes/Overlay";
import SideMenu from "../../Componentes/SideMenu";
import SideMenuBtn from "../../Componentes/SideMenuBtn";
import AddCipa from "./AddCipa";
import { useNavigate } from "react-router-dom";
import SmallLoading from "../../Componentes/Utils/SmallLoading";
import { useToast } from "../../contexts/ToastContext";
import Modal from "../../Componentes/Utils/Modal";
import ModalEmails from "./ModalEmails";
import useApi from "../../hooks/useApi";

const ContainerTabela = styled.div`
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 18px;
    overflow: auto;
    position: relative;
    display: flex;
    flex-direction: column;
`
const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
`
const CabecalhoTabela = styled.thead`
    width: 100%;
    background-color: #e0e0e0;
    color: #000;
    font-weight: bold;
    height: 45px;
    font-size: 14px;
    & th {
        text-align: left;
        box-sizing: border-box;
        padding-left: 15px;
        white-space: nowrap;
    }
    box-sizing: border-box;
    position: sticky;
    top: 0;
    z-index: 2;
`
const CorpoTabela = styled.tbody`
    background-color: white;
    color: black;
    font-size: 12px;
    & tr {
        height: 40px;
        border-bottom: 1px solid #ddd;
    }
    & tr:nth-child(even) {
        background-color: #fcfcfc;
    }
    & tr:nth-child(odd) {
        background-color: #f9f9f9;
    }
    & tr:hover {
        background-color: #edf7ff;
    }
    & td {
        padding-left: 15px;
        box-sizing: border-box;
        white-space: nowrap;
    }
`
const ContainerAcoes = styled.div`
    width: 28px;
    height: 28px;
    border-radius: 8px;
    border: 1px solid #ccc;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`
const MenuAcoes = styled.div`
    position: fixed;
    top: ${(props) => props.top}px;
    left: ${(props) => props.left}px;
    width: 200px;
    background-color: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    z-index: 1000;
    animation: fadeIn 0.2s ease-in-out, slideDown 0.2s ease-in-out;
    @keyframes slideDown {
        from { transform: translateY(-5px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
    }
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`
const ItemMenuAcoes = styled.div`
    padding: 10px 15px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    &:hover {
        background-color: #f0f0f0;
    }
    & p{
        margin: 0;
    }
    & svg{
        margin: auto 8px auto 0;
        width: 20px;
        height: 20px;
    }
`
const ContainerLoading = styled.div`
    margin: auto;
`


const Container = () => {
    const api = useApi();


    const { isModalOpen, closeModal, openModal } = useModal();
    const { notifyError, notifySuccess } = useToast();

    const [generalLoading, setGeneralLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [cipas, setCipas] = useState([]);
    const [menuAberto, setMenuAberto] = useState(null);
    const [menuPosicao, setMenuPosicao] = useState({ top: 0, left: 0, abrirParaCima: false });

    const navigate = useNavigate();

    useEffect(() => {
        const handleClickFora = (e) => {
            if (!e.target.closest(".menu-acoes") && !e.target.closest(".container-acoes")) {
                setMenuAberto(null);
            }
        };
        document.addEventListener("click", handleClickFora);
        return () => document.removeEventListener("click", handleClickFora);
    }, []);

    const fetchCipa = async () => {

        setLoading(true);

        try {

            const { data } = await api.get("/Painel/API/Cipa/GetCipas/", {
                withCredentials: true
            });

            setCipas(data);
            console.log(data);

        } catch (error) {
            console.log("Erro ao buscar Cipas: ", error);
        } finally {
            setLoading(false)
        }

    }

    useEffect(() => {
        fetchCipa();
    }, [])

    const openNewCipa = () => {
        closeModal();
        openModal('newCipa');
    }

    const navCandidatos = (centroCusto, ano) => {
        navigate(`./candidatos/${centroCusto}/${ano}`);
    }

    const startVoting = async (centro_custo, ano) => {

        setGeneralLoading(true);
        setMenuAberto(null);

        try {

            const { data } = await api.post('/Painel/API/Cipa/StartVoting/', {
                "centro_custo": centro_custo,
                "ano": ano
            })

            await fetchCipa();
            notifySuccess(data?.message);

        } catch (error) {

            console.error(error);
            notifyError(error?.response?.data?.message || 'Erro ao iniciar a votação.');

        } finally {

            setGeneralLoading(false);

        }

    }

    const navVoting = (centroCusto, ano) => {
        navigate(`./votacao/${centroCusto}/${ano}`)
    }

    const endVoting = async (centro_custo, ano) => {

        setGeneralLoading(true);
        setMenuAberto(null);

        try {

            const { data } = await api.post('/Painel/API/Cipa/EndVoting/', {
                "centro_custo": centro_custo,
                "ano": ano
            })

            console.log(data);
            await fetchCipa();
            notifySuccess(data?.message);

        } catch (error) {

            console.error(error);
            notifyError(error?.response?.data?.message || 'Erro ao encerrar a votação.');

        } finally {

            setGeneralLoading(false);

        }


    }

    const calcularPercent = (total, parcial) => {

        if (total === 0 || parcial === 0) {
            return 0;
        }

        let percent = (parcial / total) * 100
        return percent;

    }

    const [selectedCipa, setSelectedCipa] = useState({
        ano: "",
        centroCusto: ""
    })

    const openEmails = ( item ) => {

        setSelectedCipa({
            ano: item.ano,
            centroCusto: item.centro_custo
        })
        openModal('addEmails');

    }

    return (
        <>
            <ContainerTabela>
                {
                    loading ? (
                        <>
                            <ContainerLoading>
                                <SmallLoading />
                            </ContainerLoading>
                        </>
                    ) : (
                        <Tabela>
                            <CabecalhoTabela>
                                <tr>
                                    <th>CENTRO CUSTO</th>
                                    <th>ANO</th>
                                    <th>INÍCIO</th>
                                    <th>TÉRMINO</th>
                                    <th>STATUS</th>
                                    <th colSpan={2} >VOTAÇÃO</th>
                                    <th></th>
                                </tr>
                            </CabecalhoTabela>
                            {
                                cipas.length > 0 && (
                                    <CorpoTabela>
                                        {cipas.map((obj) => (
                                            <tr key={obj.id} >
                                                <td>{obj.centro_custo}</td>
                                                <td>{obj.ano}</td>
                                                <td>{obj.data_inicio ? formatarData(obj.data_inicio, true) : "-"}</td>
                                                <td>{obj.data_final ? formatarData(obj.data_final, true) : "-"}</td>
                                                <td>{obj.status}</td>
                                                <td>{obj.votaram + '/' + obj.colaboradores}</td>
                                                <td>{calcularPercent(obj.colaboradores, obj.votaram).toFixed(2) + "%"}</td>
                                                <td style={{ position: "relative" }}>
                                                    <ContainerAcoes
                                                        className="container-acoes"
                                                        onClick={(e) => {
                                                            e.stopPropagation();

                                                            const rect = e.currentTarget.getBoundingClientRect();
                                                            const alturaMenu = 120;
                                                            const espacoAbaixo = window.innerHeight - rect.bottom;
                                                            const abrirParaCima = espacoAbaixo < alturaMenu;

                                                            const top = abrirParaCima ? rect.top - alturaMenu - 5 : rect.bottom + 5;
                                                            const left = rect.left - 170;

                                                            setMenuPosicao({ top, left, abrirParaCima });
                                                            setMenuAberto(menuAberto === obj.id ? null : obj.id);
                                                        }}
                                                    >
                                                        <HiOutlineDotsHorizontal size={15} />
                                                    </ContainerAcoes>
                                                    {menuAberto === obj.id && (
                                                        <MenuAcoes
                                                            className="menu-acoes"
                                                            top={menuPosicao.top}
                                                            left={menuPosicao.left}
                                                            abrirParaCima={menuPosicao.abrirParaCima}
                                                        >
                                                            <ItemMenuAcoes onClick={() => navCandidatos(obj.centro_custo, obj.ano)}>
                                                                <IoPersonSharp />
                                                                <p>CANDIDATOS</p></ItemMenuAcoes>
                                                            {obj.status === "AGENDADA" && (
                                                                <>
                                                                    <ItemMenuAcoes onClick={() => startVoting(obj.centro_custo, obj.ano)}>
                                                                        <FaPlay />
                                                                        <p>INICIAR VOTAÇÃO</p>
                                                                    </ItemMenuAcoes>
                                                                    <ItemMenuAcoes onClick={() => openEmails( obj )}>
                                                                        <MdEmail />
                                                                        <p>LISTA E-MAILS</p>
                                                                    </ItemMenuAcoes>
                                                                </>
                                                            )}

                                                            {obj.status === "ATIVA" && (
                                                                <>
                                                                    <ItemMenuAcoes onClick={() => endVoting(obj.centro_custo, obj.ano)}>
                                                                        <FaStop />
                                                                        <p>ENCERRAR VOTAÇÃO</p>
                                                                    </ItemMenuAcoes>
                                                                    <ItemMenuAcoes onClick={() => navVoting(obj.centro_custo, obj.ano)}>
                                                                        <IoTicket />
                                                                        <p>VOTAÇÃO</p>
                                                                    </ItemMenuAcoes>
                                                                </>
                                                            )}
                                                        </MenuAcoes>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </CorpoTabela>
                                )
                            }
                        </Tabela>
                    )
                }
            </ContainerTabela>
            {
                isModalOpen('sidebarCipa') && (
                    <Overlay state={true} changeContent={closeModal} >
                        <SideMenu>
                            <SideMenuBtn
                                button="NOVA CIPA"
                                clickFunc={openNewCipa}
                            />
                        </SideMenu>
                    </Overlay>
                )
            }
            {
                isModalOpen('newCipa') && (
                    <AddCipa
                        updateCipas={fetchCipa}
                    />
                )
            }
            {
                generalLoading && (
                    <Overlay state={true} >
                        <Modal size="sm" >
                            <SmallLoading />
                        </Modal>
                    </Overlay>
                )
            }
            {
                isModalOpen('addEmails') && (
                    <ModalEmails
                        ano={ selectedCipa.ano }
                        centro_custo={ selectedCipa.centroCusto }
                    />
                )
            }
        </>
    )
}

export default Container;